import { render, staticRenderFns } from "./insuranceDetailForms.vue?vue&type=template&id=314ca29a&scoped=true&"
import script from "./insuranceDetailForms.vue?vue&type=script&lang=ts&"
export * from "./insuranceDetailForms.vue?vue&type=script&lang=ts&"
import style0 from "./insuranceDetailForms.vue?vue&type=style&index=0&id=314ca29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ca29a",
  null
  
)

export default component.exports